<template>
	<div style="background:#fff;margin:-20px;padding-bottom:20px" class="index">
		<router-link :to="{name:'shop_goods_list'}" style="position: absolute;top: 12px;left: 200px;">
			<el-button size="mini">回到商品列表</el-button>
		</router-link>
		<el-form ref="form" label-width="120px">
			<el-form-item label="商品名称">
				<el-input v-model="form.title" placeholder="请输入商品名称，不能超过60个字符" class="w-50"></el-input>
			</el-form-item>
			<el-form-item label="封面">
				<div class="u-f u-ac">
					<div v-for="(c,index) in form.cover" :key="index" class="cover_item">
						<img :src="c.url" class="rounded mr-2" style="width: 45px;height: 45px;cursor: pointer;"
							@click="chooseImage" />
						<i class="el-icon-circle-close closeimg" @click="delcover(c,index)"></i>
					</div>

					<span class="btn btn-light border mr-2 addcover" @click="chooseImage">
						<i class="el-icon-plus"></i>
					</span>
				</div>
			</el-form-item>
			<el-form-item label="商品分类">
				<el-select v-model="form.category_id" placeholder="请选择商品分类" filterable>
					<el-option :label="item | tree" v-for="(item,index) in cates" :key="index" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品描述">
				<el-input type="textarea" v-model="form.desc" placeholder="选填，商品卖点简述，例如：此款商品美观大方 性价比较高 不容错过"
					class="w-50"></el-input>
			</el-form-item>
			<el-form-item label="商品单位">
				<el-input v-model="form.unit" placeholder="请输入商品单位" class="w-50"></el-input>
			</el-form-item>
			<el-form-item label="总库存">
				<el-input type="number" v-model="form.stock" class="w-25">
					<template slot="append">件</template>
				</el-input>
			</el-form-item>
			<el-form-item label="库存预警">
				<el-input type="number" v-model="form.min_stock" class="w-25">
					<template slot="append">件</template>
				</el-input>
			</el-form-item>
			<el-form-item label="最低销售价">
				<el-input type="number" v-model="form.min_price" class="w-25">
					<template slot="append">元</template>
				</el-input>
			</el-form-item>
			<el-form-item label="最低原价">
				<el-input type="number" v-model="form.min_oprice" class="w-25">
					<template slot="append">元</template>
				</el-input>
			</el-form-item>
			<el-form-item label="积分占价格比例">
				<el-input type="number" v-model.number="form.kcurrency_pay" :min="0" :max="99" maxlength="2"
					@blur="blinput" class="w-25">
					<template slot="append">(0~99)%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="1元可抵扣积分">
				<el-input type="number" v-model="form.kcurrency_proportion" class="w-25">
					<!-- <template slot="append">元</template> -->
				</el-input>
			</el-form-item>
			<el-form-item label="赠送优惠券">
				<el-radio-group v-model="form.give_coupons">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="2">否</el-radio>
					<el-radio :label="3">默认</el-radio>
				</el-radio-group>
				<el-select v-model="form.give_coupons_id" v-if="form.give_coupons==1" placeholder="请选择优惠券"
					class="hyq_sty" size="small">
					<el-option v-for="item in yhq_options" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="已销售数量">
				<el-input type="number" v-model="form.base_sale_count" class="w-25"></el-input>
			</el-form-item>
			<el-form-item label="限购数量">
				<el-input type="number" v-model="form.quota" placeholder="不限量填0" class="w-25" min="0"></el-input>
			</el-form-item>
			<el-form-item label="库存显示">
				<el-radio-group v-model="form.stock_display">
					<el-radio :label="1" border>是</el-radio>
					<el-radio :label="0" border>否</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="是否上架">
				<el-radio-group v-model="form.status">
					<el-radio :label="0" border>放入仓库</el-radio>
					<el-radio :label="1" border>立即上架</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="是否第二件半价">
				<el-radio-group v-model="form.double_status">
					<el-radio :label="0" border>否</el-radio>
					<el-radio :label="1" border>是</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="是否热销">
				<el-radio-group v-model="form.is_hot">
					<el-radio :label="0" border>否</el-radio>
					<el-radio :label="1" border>是</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="展示平台">
				<el-radio-group v-model="form.data_source">
					<el-radio :label="1" border>快康</el-radio>
					<el-radio :label="2" border>正汉</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="专题页面">
				<el-input  v-model="form.subject_url" placeholder="输入详情返回专题页面地址" class="w-25" min="0"></el-input>
			</el-form-item>
			<el-form-item label="运费模板">
				<el-select v-model="form.express_id" placeholder="请选择运费模板">
					<el-option :label="item.name" v-for="(item,index) in express" :key="index" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="商品海报图">
				<div>
					<span v-if="!form.goods_poster_url" class="btn btn-light border mr-2" @click="pos_chooseImage">
						<i class="el-icon-plus"></i>
					</span>
					<img v-else :src="form.goods_poster_url" class="rounded"
						style="width: 45px;height: 45px;cursor: pointer;" @click="pos_chooseImage" />
				</div>
				<!-- <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload" :limit="1"
					:headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
					:file-list="hb_img" :on-success="uploadSuccess" :on-remove="uploadRmove" list-type="picture-card">
					<i class="el-icon-plus"></i>
				</el-upload> -->
			</el-form-item>
			<el-form-item label="二维码过期时间">
				<el-date-picker v-model="form.goods_poster_expiry_date" type="date" size="small"
					value-format="yyyy-MM-dd" placeholder="选择日期">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="扫码回复">
				<el-input type="textarea" :rows="3" style="max-width:600px" placeholder="请输入内容"
					v-model="form.automatic_reply">
				</el-input>
			</el-form-item>
		</el-form>
		<el-button type="primary" style="position: fixed;bottom: 50px;right: 50px;" @click="submit">提交</el-button>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		inject: ['app', 'layout'],
		data() {
			return {
				id: 0,
				cates: [],
				express: [],
				form: {
					title: "",
					category_id: "",
					cover: [],
					desc: "",
					unit: "",
					stock: "",
					min_stock: "",
					ischeck: 0,
					status: 0,
					stock_display: 0,
					express_id: "",
					min_price: "",
					min_oprice: "",
					base_sale_count: '',
					kcurrency_pay: '',
					kcurrency_proportion: '',
					give_coupons: 3,
					give_coupons_id: '',
					quota: '',
					goods_poster: '',
					goods_poster_url: '',
					automatic_reply: '',
					goods_poster_expiry_date: '',
					double_status:0,
					is_hot:0,
					data_source:1,
					subject_url:'',

				},
				yhq_options: [],
				hb_img: [],

			}
		},
		filters: {
			tree(item) {
				if (item.level == 0) {
					return item.name
				}
				let str = ''
				for (let i = 0; i < item.level; i++) {
					str += i == 0 ? '|--' : '--'
				}
				return str + ' ' + item.name;
			}
		},
		created() {
			// 获取id
			this.id = this.$route.query.id
			if (this.id) {
				// 获取之前的商品详情
				this.layout.showLoading()
				this.axios.get('/admin/goods/read/' + this.id, {
					token: true
				}).then(res => {
					let data = res.data.data
					this.form = data
					if (!Array.isArray(this.form.cover)) {
						this.form.cover = [{
							url: this.form.cover,
						}]
					}
					this.layout.hideLoading()
				}).catch(err => {
					this.layout.hideLoading()
				})
			}
			this.axios.get('/admin/goods/create', {
				token: true
			}).then(res => {
				let data = res.data.data
				this.cates = data.cates
				this.express = data.express.list
			})
		},
		watch: {
			'form.give_coupons'(nval, oval) {
				if (nval == 2 || nval == 3) {
					this.form.give_coupons_id = ''
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.user.user,
			})
		},
		mounted() {
			this.getyhq()
		},
		methods: {
			getyhq() {
				axios.get(`/admin/coupon/1?page_count=100&use_channel=2`, {
						headers: {
							token: this.user.token
						}
					})
					.then(res => {
						this.yhq_options = res.data.data.list
					})
					.catch(error => {})
			},
			chooseImage() {
				this.app.chooseImage((res) => {
					this.form.cover.push(...res)
				}, 9, '', '', '', 'goodimg')
			},
			delcover(c,i){
				this.form.cover.splice(i, 1)
			},
			pos_chooseImage() {
				this.app.chooseImage((res) => {
					this.form.goods_poster = res[0].local_url
					this.form.goods_poster_url = res[0].url
				}, 1, 1, this.id)
			},
			submit() {
				if ((this.form.kcurrency_pay - 0 < 0) || this.form.kcurrency_pay > 99) {
					return this.$message.error('范围在0~99')
				}
				if (this.form.give_coupons == 1) {
					if (!this.form.give_coupons_id) return this.$message.error('请选择要赠送的优惠券')
				}
				this.layout.showLoading()
				let url = this.id ? '/admin/goods/' + this.id : '/admin/goods'
				this.axios.post(url, this.form, {
					token: true
				}).then(res => {
					this.layout.hideLoading()
					if (res.data.code == '200') {
						this.$message({
							type: "success",
							message: this.id ? "修改成功" : "发布成功"
						})
						this.$router.push({
							name: "shop_goods_list"
						})
					} else {
						this.$message({
							type: "error",
							message: res.data.msg
						})
					}
				}).catch(err => {
					this.layout.hideLoading()
				})
			},
			blinput() {
				if ((this.form.kcurrency_pay - 0 < 0) || this.form.kcurrency_pay > 99) {
					return this.$message.error('范围在0~99')
				}
			},
			// 
			uploadSuccess(response, file, fileList) {
				let that = this
				if (response.code == "201") {
					that.$nextTick(() => {
						let mainImg = that.$refs.upload;
						if (mainImg) {
							mainImg.uploadFiles.forEach((element, index) => {
								if (file.uid == element.uid) {
									mainImg.uploadFiles.splice(index, 1)
								}
							});
						}
					})
					that.$alert(response.msg)
					return;
				}
				that.$message({
					message: '上传成功',
					type: 'success'
				});
				that.form.goods_poster = response.data.url
			},
			uploadRmove(file, fileList) {
				this.form.goods_poster = ''
			},
		},
	}
</script>

<style lang='scss' scoped>
	.index {
		padding: 10px 0;
	}

	.goods_create .el-form-item {
		margin-bottom: 15px;
	}

	.hyq_sty {
		margin-left: 20px;
	}
	.cover_item{
		position: relative;
		img{
			display: block;
		}
		.closeimg{
			position: absolute;
			top: -12px;
			right: 0;
			cursor: pointer;
		}
	}
	.addcover{
		height: 45px;
		width: 45px;
		display: flex;
		align-items: center;

	}
</style>